import { dateTime, SessionReviewUI } from '@shared';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { examSessionsApi } from 'App';

export function useExamSessionReview(session: string): UseQueryResult<SessionReviewUI> {
  return useQuery(['exam session', session], () => examSessionsApi.getSessionReview(session), {
    select: (data) => ({
      partner: {
        name: data.partner.name,
        uuid: data.partner.uuid,
      },
      course: {
        name: data.course.name,
        uuid: data.course.uuid,
      },
      exam: {
        name: data.exam.label,
        uuid: data.exam.uuid,
      },
      examSession: {
        uuid: data.examSession.uuid,
        startTime: dateTime(data.examSession.startTime, 'start time'),
        endTime: dateTime(data.examSession.endTime, 'end time'),
      },
      user: {
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        uuid: data.user.uuid,
      },
      profileTraceHandle: data.profileTraceHandle,
      documentTraceHandle: data.documentTraceHandle,
      roomScanTraceHandle: data.roomScanTraceHandle,
      muxedVideoHandle: data.muxedVideoHandle,
      streamResponse: {
        streamHandle: data.streamResponse.handle,
        videoStartClock: data.streamResponse.videoStartClock,
        videoEndClock: data.streamResponse.videoEndClock,
      },
      audits: data.auditViews.map(({ audit, auditorFullName }) => ({
        uuid: audit.uuid,
        startTime: dateTime(audit.startTime, 'start time'),
        endTime: dateTime(audit.endTime, 'end time'),
        auditorFullName,
      })),
      anomalyTypeViews: data.anomalyTypeViews,
    }),
  });
}
